module.exports = __webpack_public_path__ + "img/wish_alter.57ad9acf.png";